import {Col, Row} from 'antd';
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';
import {HorizontalNav} from 'src/components';
import {HorizontalNavSize} from 'src/components/HorizontalNav';
import Artists from './Artists';
import Arts from './Arts';
import styles from './index.module.scss';

export default function Explore() {
  const {path} = useRouteMatch();

  return (
    <>
      <Row>
        <Col span={24}>
          <div className={styles.nav}>
            <HorizontalNav
              size={HorizontalNavSize.Small}
              links={[
                [`${path}/artists`, 'Explore Artists'],
                [`${path}/arts`, 'Explore Art'],
              ]}
            />
          </div>
        </Col>
      </Row>
      <Switch>
        <Route path={`${path}/arts`}>
          <Arts />
        </Route>

        <Route path={`${path}/artists`}>
          <Artists />
        </Route>

        <Redirect to={`${path}/artists`} />
      </Switch>
    </>
  );
}
